import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ProjectCard from '../components/ProjectCard';
import API_URL from '../config/api';
import './Projects.css';

const Projects = ({ user }) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [pendingQuestions, setPendingQuestions] = useState(0);

  useEffect(() => {
    if (user) {
      fetchProjects();
      if (user.role === 'respondent') {
        checkPendingQuestions();
      }
    }
  }, [user]);

  const fetchProjects = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/projects`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setProjects(response.data);
    } catch (error) {
      setError('Failed to load projects');
      console.error('Error fetching projects:', error);
    } finally {
      setLoading(false);
    }
  };

  const checkPendingQuestions = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/qualifications/country-questions`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      // Count of unanswered questions
      const unansweredCount = response.data.questions ? response.data.questions.length : 0;
      setPendingQuestions(unansweredCount);
    } catch (error) {
      console.error('Error checking pending questions:', error);
      setPendingQuestions(0);
    }
  };

  const handleTakeProject = (project) => {
    // Navigate to project taking page
    window.location.href = `/projects/${project._id}/take`;
  };

  // Show all projects without filtering
  const filteredProjects = projects;

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="projects-page">
      <div className="container">
        <div className="projects-header">
          <h1>Available Surveys</h1>
          <p>Browse and participate in surveys to earn points</p>
        </div>

        {user?.role === 'respondent' && pendingQuestions > 0 && (
          <div className="profile-warning">
            <div className="warning-content">
              <h3>Complete Your Profile</h3>
              <p>Complete your profile to see more relevant projects and earn more points.</p>
              <Link to="/survey-profiler/all" className="btn btn-primary">
                Complete Survey Profiler
              </Link>
            </div>
          </div>
        )}



        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}

        <div className="projects-content">
          {filteredProjects.length > 0 ? (
            <div className="projects-grid">
              {filteredProjects.map(project => (
                <ProjectCard
                  key={project._id}
                  project={project}
                  user={user}
                  onTakeProject={handleTakeProject}
                />
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <div className="empty-state-icon">📝</div>
              <h3 className="empty-state-title">No projects found</h3>
              <p className="empty-state-description">
                  {user?.role === 'client'
                    ? 'Create your first project to get started'
                    : 'Check back later for new survey opportunities'
                }
              </p>
              {user?.role === 'client' && (
                <Link to="/projects/create" className="btn btn-primary">
                  Create Your First Project
                </Link>
              )}
            </div>
          )}
        </div>

        {user?.role === 'client' && (
          <div className="client-actions">
            <Link to="/projects/create" className="btn btn-primary btn-lg">
              Create New Project
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Projects;
